import script from "./HeaderBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBlindenzorglichtliefde.vue?vue&type=style&index=0&id=67163628&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67163628"]])

export default __exports__